import * as _ from "lodash";

import { ExtensionBase } from "../extensionBase";
import { UiUtils } from "../../common/uiUtils";
import { WebPanel } from "./webPanel";
import { addDndListener, viewerOptions } from "../../viewer";


export class WebExtension extends ExtensionBase {

    static extensionName = "WebExtension";

    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private panel: WebPanel;


    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
    }

    static registerExtension() {
        super.registerExtension(WebExtension.extensionName, WebExtension);
    }

    load(): boolean {
        console.log(`${WebExtension.extensionName} is loaded!`);

        this.panel = new WebPanel(this.viewer);
        return super.load();
    };

    unload(): boolean {
        this.viewer.getToolbar(false).removeControl(this.subToolbar);
        return super.unload();
    };

    onToolbarCreated(): void {
        const webButton = UiUtils.createButton({
            id: "SmartDrawings.WebButton",
            tooltip: "Details",
            iconClass: "ion-md-browsers",
            onClick: () => {
                this.panel.setVisible(!this.panel.isVisible());
            }
        });

        this.panel.addVisibilityListener(visible => {

            webButton.setState(visible ? Autodesk.Viewing.UI.Button.State.ACTIVE : Autodesk.Viewing.UI.Button.State.INACTIVE);
        });

        this.subToolbar = this.getControlGroup("SmartDrawings.Extensions");
        this.subToolbar.addControl(webButton);
    }

}